import { AwsRum, type AwsRumConfig } from 'aws-rum-web';

const APPLICATION_ID = 'ba97881c-7fe4-447e-b9c1-d39964160229';
const APPLICATION_VERSION = '1.0.0';
const APPLICATION_REGION = 'us-east-1';

const config: AwsRumConfig = {
  sessionSampleRate: 1,
  endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
  telemetries: ['performance', 'errors', 'http', 'interaction'],
  allowCookies: true,
  enableXRay: false,
  signing: true,
  identityPoolId: "us-east-1:0e2cae2c-663a-46b7-aca0-d2256a093269",
};

let rumInstance: AwsRum | null = null;

export const initRum = (): void => {
  if (rumInstance) return;

  try {
    rumInstance = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );
  } catch (error) {
    console.warn('[CloudWatch RUM] Failed to initialize:', error);
  }
};


export const rumClient = (): AwsRum | null => rumInstance;